export interface Category {
  name: string;
  slug: string;
  url: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    description: 'Trending sneakers, boots, and designer footwear sourced from top Chinese suppliers with verified quality ratings.',
  },
  {
    name: 'Hoodies / Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    description: 'Premium hoodies and knitwear collections perfect for streetwear brands and seasonal drops.',
  },
  {
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    description: 'High-quality cotton, oversized, and graphic tees with competitive factory pricing and fast turnaround.',
  },
  {
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-contrast-drop-2-line',
    description: 'Bombers, puffers, denim jackets, and technical outerwear sourced from trusted manufacturing hubs.',
  },
  {
    name: 'Pants / Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    description: 'Cargo pants, denim, joggers, and summer shorts — curated for resellers and boutique owners.',
  },
  {
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-base-station-line',
    description: 'Caps, beanies, bucket hats, and snapbacks from manufacturers with custom embroidery options.',
  },
  {
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    description: 'Coordinated two-piece and three-piece outfit sets that move fast on TikTok Shop and Instagram.',
  },
  {
    name: 'Underwear / Underpants',
    slug: 'underwear-underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-box-1-line',
    description: 'Seamless, cotton, and shapewear essentials with bulk order discounts for growing brands.',
  },
  {
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-football-line',
    description: 'Sports jerseys, retro kits, and team apparel — high-demand niches with strong resale margins.',
  },
  {
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    description: 'Sunglasses, watches, jewelry, phone cases, and small add-on items that boost average order value.',
  },
  {
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
    description: 'Backpacks, crossbody bags, totes, and luxury-inspired styles with strong international demand.',
  },
  {
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    description: 'Leather belts, designer buckle styles, and casual accessories built for high-volume reselling.',
  },
  {
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    description: 'Inspired fragrances, luxury perfume alternatives, and niche scent collections from reliable labs.',
  },
  {
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    description: 'Home goods, electronics, toys, and miscellaneous trending finds updated weekly on the spreadsheet.',
  },
];

export const popularCategories = [
  'Shoes',
  'Hoodies / Sweaters',
  'T-Shirts',
  'Jackets',
  'Accessories',
  'Bags',
];